import { ThemeEvents } from "@theme/events";

export class MenuAccordion extends HTMLElement {
    button = this.querySelector('[ref="button"]');

    content = this.querySelector('[ref="content"]');

    isOpen = false;

    constructor() {
        super();

        if (typeof $ !== 'function') {
            throw new Error('$ is not detected at MenuAccordion');
        }
    }

    connectedCallback() {
        this.button?.addEventListener('click', this.toggle.bind(this));
        document.addEventListener(ThemeEvents.cartUpdate, this.#close.bind(this));
    }

    disconnectedCallback() {
        this.button?.removeEventListener('click', this.toggle.bind(this));
    }

    /**
     * @param {PointerEvent} event 
     */
    toggle(event) {
        if (!this.content) return;
        this.isOpen ? this.#close() : this.#open();
    }

    #open() {
        $(this.content).slideDown(150);
        this.isOpen = true;
        this.classList.add('active');
    }

    #close() {
        $(this.content).slideUp(150);
        this.isOpen = false;
        this.classList.remove('active');
    }
}

if (!customElements.get('menu-accordion')) {
    customElements.define('menu-accordion', MenuAccordion);
}